import { render, staticRenderFns } from "./LiveCommodity.vue?vue&type=template&id=acdf99e8&scoped=true&"
import script from "./LiveCommodity.vue?vue&type=script&lang=js&"
export * from "./LiveCommodity.vue?vue&type=script&lang=js&"
import style0 from "./LiveCommodity.vue?vue&type=style&index=0&id=acdf99e8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "acdf99e8",
  null
  
)

export default component.exports